<template lang="pug">
  div.lmm-content-body-padded
    sub-header
    b-container(fluid)
      b-row.mb-2
        b-col(cols="12")
          b-button.mr-1(
            size="sm",
            :class="{active: query.type === 'monthly'}",
            @click="setMonthly") {{$t('by_monthly')}}
          b-button.mr-1(
            size="sm",
            :class="{active: query.type === 'daily'}",
            @click="setDaily") {{$t('by_daily')}}
          datepicker(
            class="hidden-picker",
            ref="datepicker",
            :value="query.date",
            :minimumView="picker.min",
            :maximumView="picker.max",
            :bootstrap-styling="true",
            format="yyyy-MM-dd",
            :language="picker.lang",
            @selected="dateChanged")
          b-button(size="sm", @click="showDatepicker") {{$t('select_date')}}: {{query.string}}
      b-row
        b-col(cols="6")
          b-card(no-body)
            div(slot="header") {{$t('count_of_alert')}}
            b-table(
              :fields="fields",
              :items="items")
              template(slot="HEAD_start_date", slot-scope="data")
                | {{$t('date')}}
              template(slot="HEAD_access_cnt", slot-scope="data")
                | {{$t('use_count')}}
              template(slot="HEAD_access_ratio_string", slot-scope="data")
                | {{$t('rate')}}
        b-col(cols="6")
          b-card(v-if="ready")
            div(slot="header") {{$t('chart')}}
            bar-chart(:chart-data="chartData", :options="chartOptions")
</template>

<script>
import _ from 'lodash'
import {getCurrentLanguage} from '@/i18n'
import * as datePickerLocale from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import BarChart from './bar-chart'
import {AnalysticAPI} from '../../api'

const padd = (n) => {
  let ns = n.toString()
  if (ns.length === 1) ns = '0' + ns
  return ns
}

export default {
  name: 'rate-warning-component',
  components: { BarChart, Datepicker },
  methods: {
    setMonthly () {
      let date = this.query.date
      this.query.type = 'monthly'
      this.query.year = date.getFullYear()
      this.query.string = this.query.year.toString()
      this.query.prefix = this.query.string + '-'

      this.picker.min = 'year'
      this.picker.max = 'year'
      this.getData()
    },
    setDaily () {
      let date = this.query.date
      this.query.type = 'daily'
      this.query.year = date.getFullYear()
      this.query.month = date.getMonth() + 1
      this.query.string = this.query.year + '-' + padd(this.query.month)
      this.query.prefix = this.query.string + '-'

      this.picker.min = 'month'
      this.picker.max = 'year'
      this.getData()
    },
    showDatepicker () {
      this.$refs.datepicker.showCalendar()
    },
    dateChanged (date) {
      this.query.date = date
      if (this.query.type === 'monthly') {
        this.query.year = date.getFullYear()
        this.query.string = this.query.year.toString()
        this.query.prefix = this.query.string + '-'
      } else if (this.query.type === 'daily') {
        this.query.year = date.getFullYear()
        this.query.month = date.getMonth() + 1
        this.query.string = this.query.year + '-' + padd(this.query.month)
        this.query.prefix = this.query.string + '-'
      }
      this.getData()
    },
    getData () {
      let params = {
        type: this.query.type,
        year: this.query.year,
        month: this.query.month
      }
      AnalysticAPI.chart.get('alert', {params})
        .then(resp => {
          let data = resp.data.objects
          data = _.map(data, (v, i) => {
            if (v.pk !== 'EMPTY') {
              v.access_ratio_string = v.access_ratio.toFixed(2) + ' %'
            } else {
              v.start_date = this.query.prefix + padd(i + 1)
              v.access_cnt = 0
              v.access_ratio = 0
              v.access_ratio_string = '0.00 %'
            }
            return v
          })
          this.items = data
          this.chartData = {
            labels: _.map(data, (v, i) => (i + 1).toString()),
            datasets: [
              {
                label: this.$t('count_of_alert'),
                backgroundColor: '#f87979',
                data: _.map(data, v => v.access_cnt)
              }
            ]
          }
          this.ready = true
        })
    }
  },
  created () {
    const now = new Date()
    this.query.type = 'monthly'
    this.query.year = now.getFullYear()
    this.query.month = now.getMonth() + 1
    this.query.date = now
    this.query.string = this.query.year.toString()
    this.query.prefix = this.query.string + '-'
  },
  mounted () {
    this.getData()
  },
  data () {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      ready: false,
      query: {},
      picker: {
        min: 'year',
        max: 'year',
        lang: datePickerLocale[getCurrentLanguage()]
      },
      fields: [
        { key: 'start_date', label: this.$t('date') },
        { key: 'access_cnt', label: this.$t('use_count') },
        { key: 'access_ratio_string', label: this.$t('use_rate') }
      ],
      items: [],
      chartData: null,
      chartOptions: {
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              suggestedMin: 0,
              suggestedMax: 50
            }
          }]
        }
      }
    }
  }
}
</script>
